import './App.css';
// import { ThemeProvider, createTheme } from '@mui/material/styles';
import { Switch, Route, useLocation } from 'react-router-dom';
import React, { useReducer, useEffect, useState, useRef } from 'react';
import { AnimatePresence } from 'framer-motion';
import { UserContext } from './contexts/userContext';
import NotFound from './items/404/NotFound';
import PaymentPrompt from './machineUI/paymentPrompt';
import ProductDispense from './machineUI/productDispense';
import EmailCode from './machineUI/EmailCode';
import MachineSignIn from './auth/MachineSignIn';
import ImageSlider from './machineUI/items/ImageSlider';
import IdleTimer from './machineUI/items/IdleTimer';
import Initial from './machineUI/items/Initial';
import Logout from './auth/Logout';
import Synch from './items/Synch';
import Home from './machineUI/home';
import CategoryPage from './machineUI/Category/CategoryPage';
import Disability from './machineUI/items/Disability';

import OutOfOrder from './machineUI/outOfOrder';
import DescriptionPage from './machineUI/Description/DescPage';
import CartFullModal from './machineUI/items/CartFullModal';
import request from './services/Request';
// import { defaultStat } from '../src/staticData/stats';
import { setVariable } from './services/servicesFunc';
import SelectPayment from './machineUI/SelectPayment';
import CashPayment from './machineUI/CashPayment';
import { outOfOrderRequest } from './machineUI/outOfOrderRequest';
import p from '../package.json';
import localRequest from './services/LocalServer/localRequest';
import LoadingIcon from './items/buttons/LoadingIcon';
import Swal from 'sweetalert2';
import { submitPromo, clearPromo } from './services/promo';
import { useHistory } from 'react-router';
import { sleep } from './services/methods';
import logger from './services/LocalServer/logger';
import ScanPage from './machineUI/company/HF/ScanPage';
import { useTranslation } from 'react-i18next';
import ProductInventory from './machineUI/TechMode/ProductInventory';
import LockerInventory from './machineUI/TechMode/LockerInventory';
import isvpayWebSocketService from './services/isvpayWebSocketService';
import NetworkStatusIndicator from './components/NetworkStatusIndicator';

const LOCAL_STORAGE_KEY = 'MagexApp.cart';
let MAXCARTNUM = 3;

try {
  if (localStorage.getItem('MAX_CART')) {
    MAXCARTNUM = parseInt(localStorage.getItem('MAX_CART'));
  } else {
    localStorage.setItem('MAX_CART', MAXCARTNUM);
  }
} catch (e) {
  localStorage.setItem('MAX_CART', MAXCARTNUM);
  console.log(e);
}

function App() {
  const { t } = useTranslation();
  const history = useHistory();
  const location = useLocation();
  const [cartQuantity, setCartQuantity] = useState(0);

  //restore user information from localstorage
  const loggedInUser = JSON.parse(localStorage.getItem('user'));
  let initialState = { login: false, userName: '', role: '', email: '' };
  if (loggedInUser) {
    initialState.login = true;
    initialState.userName = loggedInUser.firstname;
    initialState.role = loggedInUser.role;
    initialState.email = loggedInUser.email;
    initialState.referTo = loggedInUser.referTo;
    initialState.fullAccess = loggedInUser.fullAccess;
    initialState.limits = loggedInUser.limits;
  }

  //user state
  const [loginStatus, setLoginStatus] = useState(initialState.login);
  const [user, setUser] = useState(initialState);
  const [userName, setUserName] = useState(initialState.userName);
  const [role, setRole] = useState(initialState.role);
  const [userEmail, setUserEmail] = useState(initialState.email);
  const [referTo, setReferTo] = useState(initialState.referTo);
  const [fullAccess, setFullAccess] = useState(initialState.fullAccess);
  //for checkout and cart
  const [machineID, setMachineID] = useState('');
  const [machine, setMachine] = useState(null);
  const [testMode, setTestMode] = useState(false);
  const [langs, setlangs] = useState('en');
  const [cartFull, setCartFull] = useState(false);
  const [clientUser, setClientUser] = useState(null);

  const [themeColor, setThemeColor] = useState({});

  const [loading, setLoading] = useState(false);

  // Network status monitoring
  const [isServerConnected, setIsServerConnected] = useState(true);
  const [lastChecked, setLastChecked] = useState(new Date());

  //hello Fresh
  const [HFuser, setHFuser] = useState({
    _id: '',
    hfid: '',
    email: '',
    firstname: '',
    lastname: '',
    cate: [],
  });

  //for initial category page
  const [idle, setIdle] = useState(0);

  const [showCart, setShowCart] = useState(false);
  const [products, setProds] = useReducer(productsReducer, []);

  const [audio, setAudio] = useState({
    start: null,
    cart: null,
    checkout: null,
    dispense: null,
    doorOpen: null,
    doorClose: null,
  });

  const stopPlay = () => {
    if (audio?.start) {
      console.log('stop Play');
      audio.start?.pause();
      audio.start.currentTime = 0;
    }
    if (audio?.cart) {
      audio.cart?.pause();
      audio.cart.currentTime = 0;
    }
    if (audio?.checkout) {
      audio.checkout?.pause();
      audio.checkout.currentTime = 0;
    }
    if (audio?.dispense) {
      audio.dispense?.pause();
      audio.dispense.currentTime = 0;
    }
    if (audio?.doorOpen) {
      audio.doorOpen?.pause();
      audio.doorOpen.currentTime = 0;
    }
    if (audio?.doorClose) {
      audio.doorClose?.pause();
      audio.doorClose.currentTime = 0;
    }
  };

  const defaultStat = {
    session_com: 0,
    cart_aband: 0,
    all_prod: 0,
    all_brand: 0,
    payment: 0,
    language: {
      en: 0,
      fr: 0,
      es: 0,
      zh: 0,
    },
    cart_page: 0,
    faq: 0,
    cate: [],
    prod: [],
    brand: [],
    banner: {},
    session_time: 0,
    time: new Date(),
  };

  const [stat, setStat] = useState(defaultStat);
  const [cart, setCart] = useReducer(cartReducer, []);
  const [linkPromo, setLinkPromo] = useState({ p: '', id: '' });

  const promoRef = useRef(0);
  const productRef = useRef(0);
  const cartRef = useRef(0);
  const closePromoModalRef = useRef(0);

  //always check oos status
  useEffect(() => {
    const runSet = async () => {
      await setVariable();

      // 通知后端前端已启动
      try {
        await localRequest({
          method: 'post',
          url: '/frontend/startup',
        });
        logger(2, 'Frontend startup notification sent to backend');
      } catch (error) {
        logger(0, `Failed to notify backend of frontend startup: ${error.message}`);
      }

      // 初始化ISVPay连接（如果支付方式是ISVPAY）
      const paymentMethod = localStorage.getItem('PAYMENT_METHOD');
      if (paymentMethod === 'ISVPAY') {
        // 使用重试机制立即启动ISVPay连接
        (async () => {
          try {
            logger(
              2,
              'Initializing ISVPay WebSocket connection on app startup with retry mechanism'
            );
            await isvpayWebSocketService.ensureConnection();
            logger(2, 'ISVPay WebSocket connection established successfully on app startup');
          } catch (error) {
            const errorMsg =
              error?.message || 'Unknown connection error - ISVPay middleware may not be ready yet';
            logger(0, `Failed to initialize ISVPay connection on app startup: ${errorMsg}`);
            // 不抛出错误，允许应用继续运行，支付时会再次尝试连接
          }
        })();
      }
    };

    runSet();
    const mid = localStorage.getItem('machineID');
    if (mid && !(process.env.REACT_APP_DEV === 'TRUE')) {
      var outInterval = setInterval(() => outOfOrderRequest(outInterval, mid), 2000);
    }
    return () => {
      clearInterval(outInterval);
    };
  }, []);

  useEffect(() => {
    logger(2, 'Current Route:' + location.pathname);
  }, [location]);

  useEffect(() => {
    const productsStock = JSON.parse(localStorage.getItem('products'));
    if (productsStock) {
      setProds({ productsStock, type: 'set' });
    }
  }, []);

  useEffect(() => {
    localStorage.setItem('products', JSON.stringify(products));
    productRef.current = products;
  }, [products]);

  useEffect(() => {
    console.log('showCart', showCart);
    if (showCart) {
      stat.cart_page += 1;
      setStat(stat);
    }
  }, [showCart]);

  //bar code reader

  useEffect(() => {
    if (localStorage.getItem('REACT_APP_BARCODE') === 'TRUE') {
      let barcode = '';
      let interval;
      let preDate = new Date();

      const readBarcode = (evt) => {
        if (interval) {
          clearInterval(interval);
        }

        if (evt.code === 'Enter') {
          if (barcode) handleBarcode(barcode, preDate);
          barcode = '';
          return;
        }
        if (evt.code !== 'Shift' && evt.code !== 'ShiftLeft' && evt.code !== 'ShiftRight') {
          barcode += evt.key;
        }
        interval = setInterval(() => (barcode = ''), 20);
        return;
      };
      // if (localStorage.getItem('BARCODE') === 'TRUE') {
      document.addEventListener('keydown', readBarcode);
      // }

      const handleBarcode = async (bq, pre) => {
        const nowDate = new Date();
        document?.activeElement?.blur();
        //add scan cooldown 5 seconds
        if (
          nowDate.getTime() - pre.getTime() > 5000 &&
          (window.location.pathname.indexOf('/machineUI/category') === 0 ||
            window.location.pathname.indexOf('/machineUI/slider') === 0 ||
            window.location.pathname.indexOf('/machineUI/brands') === 0 ||
            window.location.pathname.indexOf('/machineUI/homePage') === 0)
        ) {
          preDate = nowDate;
          if (window.location.pathname.indexOf('/machineUI/slider') === 0) {
            setLoading(true);
            console.log('slider');
            const mid = localStorage.getItem('machineID');
            logger(2, '[Barcode]| From Slider to Initial Page');
            history.push(`/machineUI/home/${mid}/${testMode}`);
            await sleep(5000);
          }

          console.log('barcode', bq);
          logger(2, '[Barcode]| Barcode Entered: ' + bq);
          // console.log('pre', pre);

          let found = false;
          const promoData = JSON.parse(localStorage.getItem('promo'));
          // const productData = JSON.parse(localStorage.getItem('products'));
          //when promoModal is not open
          if (!promoRef.current) {
            if (cartRef.current.length === 0) {
              // setLoading(true);
              if (promoData) {
                const copy = productRef.current;
                const myProds = [...copy];

                for (let i = 0; i < promoData.length; i++) {
                  const e = promoData[i];
                  if (e.code == bq || e.oneTimeCode?.includes(bq)) {
                    logger(2, '[Barcode]| Code Is Found In Database: ' + bq);
                    if (e.cateOrProd === 'prod') {
                      if (e.promoType === 'generalWithCode') {
                        // console.log('productRef', myProds);
                        if (e.product?.length === 1) {
                          for (let i = 0; i < e.product.length && !found; i++) {
                            for (let j = 0; j < myProds.length && !found; j++) {
                              if (e.product[i]._id == myProds[j]._id) {
                                // console.log('findpromo', myProds[j]);
                                const disPrice = e.percentage
                                  ? myProds[j].price - myProds[j].price * e.amount
                                  : myProds[j].price - e.amount;
                                found = true;
                                if (myProds[j].current_stock > 0) {
                                  add({
                                    idx: parseInt(myProds[j].idx),
                                    oneTime: e.code,
                                    id: myProds[j]._id,
                                    _id: myProds[j]._id,
                                    key: myProds[j]._id,
                                    upc: myProds[j]?.upc,
                                    name: myProds[j].name,
                                    title: myProds[j].name,
                                    promo: e._id,
                                    price: myProds[j].price,
                                    discount: myProds[j].discount ? myProds[j].discount : 0,
                                    percentage: myProds[j].percentage,
                                    discountedPrice: myProds[j].discountedPrice
                                      ? myProds[j].discountedPrice
                                      : myProds[j].price,
                                    image: myProds[j].productPictures[0],
                                    buyX: myProds[j].buyX ? myProds[j].buyX : 0,
                                    quantity: 1,
                                    category: myProds[j].category,
                                    ingredients: myProds[j].ingredients,
                                    referTo: myProds[j].referTo,
                                    prodType: myProds[j].prodType,
                                    current_stock: myProds[j].current_stock,
                                    emailCode: myProds[j].emailCode,
                                    addition: myProds[j].addition,
                                    tax_type: myProds[j].tax_type,
                                    code: bq,
                                    promoType: e.promoType,
                                  });
                                  changePrice(
                                    { id: myProds[j]._id },
                                    e.amount,
                                    disPrice,
                                    0,
                                    e.percentage,
                                    e._id
                                  );
                                  setLoading(true);
                                  setShowCart(true);
                                  const checkout = document.getElementById('check-out-button');
                                  if (checkout) {
                                    checkout.click();
                                  }
                                } else {
                                  Swal.fire({
                                    showConfirmButton: false,
                                    timer: 1500,
                                    timerProgressBar: true,
                                    text: 'Item Out Of Stock',
                                    icon: 'error',
                                  });
                                  logger(2, '[Barcode]| Item Out Of Stock: ' + myProds[j]?.upc);
                                }
                                setLoading(false);
                                return;
                              }
                            }
                          }
                        } else {
                          logger(2, '[Barcode]| Code Is Not For One Product only: ' + bq);
                        }
                      }

                      if (e.promoType === 'oneTime' || e.promoType === 'nextPurchase') {
                        console.log('oneTimeCode', e.oneTimeCode);
                        console.log('bq', bq);
                        if (e.oneTimeCode.includes(bq)) {
                          console.log('333333');
                          //send request to database check
                          await request({
                            method: 'post',
                            url: '/promos/authCode',
                            data: {
                              promo: e._id,
                              input: bq,
                            },
                            timeout: 5000,
                          })
                            .then(() => {
                              console.log('444444');
                              localStorage.setItem('oneTime', JSON.stringify(e));
                              if (e.product?.length === 1) {
                                console.log('4.55');
                                for (let j = 0; j < myProds.length; j++) {
                                  for (let i = 0; i < e.product.length; i++) {
                                    if (e.product[i]._id == myProds[j]._id) {
                                      found = true;
                                      if (myProds[j].current_stock > 0) {
                                        console.log('555555');
                                        const disPrice = e.percentage
                                          ? myProds[j].price - myProds[j].price * e.amount
                                          : myProds[j].price - e.amount;
                                        add({
                                          idx: parseInt(myProds[j].idx),
                                          id: myProds[j]._id,
                                          _id: myProds[j]._id,
                                          key: myProds[j]._id,
                                          upc: myProds[j]?.upc,
                                          name: myProds[j].name,
                                          title: myProds[j].name,
                                          promo: e._id,
                                          price: myProds[j].price,
                                          discount: myProds[j].discount ? myProds[j].discount : 0,
                                          percentage: myProds[j].percentage,
                                          discountedPrice: myProds[j].discountedPrice
                                            ? myProds[j].discountedPrice
                                            : myProds[j].price,
                                          image: myProds[j].productPictures[0],
                                          buyX: myProds[j].buyX ? myProds[j].buyX : 0,
                                          quantity: 1,
                                          category: myProds[j].category,
                                          ingredients: myProds[j].ingredients,
                                          referTo: myProds[j].referTo,
                                          prodType: myProds[j].prodType,
                                          current_stock: myProds[j].current_stock,
                                          emailCode: myProds[j].emailCode,
                                          addition: myProds[j].addition,
                                          tax_type: myProds[j].tax_type,
                                          oneTime: bq,
                                          code: bq,
                                          promoType: e.promoType,
                                        });
                                        changePrice(
                                          { id: myProds[j]._id },
                                          e.amount,
                                          disPrice,
                                          0,
                                          e.percentage,
                                          e._id
                                        );
                                        console.log('fffffff');
                                        setShowCart(true);
                                        const checkout =
                                          document.getElementById('check-out-button');
                                        if (checkout) {
                                          checkout.click();
                                        }
                                      } else {
                                        Swal.fire({
                                          showConfirmButton: false,
                                          timer: 1500,
                                          timerProgressBar: true,
                                          text: 'Item Out Of Stock',
                                          icon: 'error',
                                        });
                                        logger(
                                          2,
                                          '[Barcode]| Item Out Of Stock: ' + myProds[j]?.upc
                                        );
                                      }
                                      setLoading(false);
                                      return;
                                    }
                                  }
                                }
                              } else {
                                logger(2, '[Barcode]| Code Is Not For One Product only: ' + bq);
                              }
                            })
                            .catch((e) => {
                              logger(
                                2,
                                '[Promo]| One Time Promo Auth Failed: ' + JSON.stringify(e)
                              );
                              console.log('error during scan one time', e);
                            });
                        }
                      }
                    } else {
                      logger(2, '[Barcode]| Code Is Not For One Product only: ' + bq);
                    }
                  }
                }
                if (!found) {
                  console.log('!11112312312312312');
                  Swal.fire({
                    showConfirmButton: false,
                    timer: 1500,
                    timerProgressBar: true,
                    text: 'Bar Code Is Not Valid',
                    icon: 'error',
                  });
                  logger(2, '[Promo]| Code Not Found/Invalid: ' + bq);
                  setLoading(false);
                }
              }
            } else {
              logger(2, '[Barcode]| Shopping Cart Is Not Empty: ' + bq);
            }
          } else {
            //when promoModal is open
            if (promoData) {
              clearPromo(cartRef.current, changePrice, productRef.current);
              found = await submitPromo(promoData, bq, cartRef.current, changePrice, request);
              const promoClose = document.getElementById('close_promo_modal');
              if (found === 1 && promoClose) {
                // console.log('promomodal', promoClose);
                promoClose.click();
                Swal.fire({
                  showConfirmButton: false,
                  timer: 1500,
                  timerProgressBar: true,
                  text: 'Bar Code Applied',
                  icon: 'success',
                });
              }
              if (!found) {
                // console.log('!11112312312312312');
                Swal.fire({
                  showConfirmButton: false,
                  timer: 1500,
                  timerProgressBar: true,
                  text: 'Bar Code Is Not Valid',
                  icon: 'error',
                });
                setLoading(false);
              }
            }
          }
        }

        //promo
        // }
      };

      return () => {
        document.removeEventListener('keydown', readBarcode);
      };
    }
  }, []);

  function productsReducer(state, action) {
    switch (action.type) {
      case 'set':
        return [...action.productsStock];
      case 'add':
        return [...action.product];
      case 'clean': {
        const update = [];
        return update;
      }
      case 'decrement': {
        const productIndex = state.findIndex((item) => item._id === action.product._id);
        if (productIndex < 0) {
          return state;
        }

        if (cartQuantity < MAXCARTNUM || action.product.current_stock < action.qtt) {
          if (action.product.current_stock > action.qtt) {
            if (
              action.mycart?.length === 1 &&
              (action.mycart[0].promoType === 'oneTime' ||
                action.mycart[0].promoType === 'nextPurchase')
            )
              return state;
          }
          // console.log('action.qtt', action.qtt);
          // console.log('action.product.current_stock', action.product.current_stock);
          const update = [...state];
          update[productIndex].current_stock = action.qtt;
          // // reduce all current_stock for category limit
          // if (action.product.category?.length > 0 && action.product.limit > 0) {
          //   let cate = action.product.category[0];
          //   update.forEach((pd, index) => {
          //     if (
          //       pd.category?.length > 0 &&
          //       pd.category[0] === cate &&
          //       pd._id !== action.product._id
          //     ) {
          //       // console.log('action.qtt', action.qtt, index);
          //       // console.log('pd.current_stock', pd.current_stock, index);
          //       //increase stock
          //       if (action.product.current_stock < action.qtt) {
          //         console.log('currentbefore111', pd.current_stock);
          //         pd.current_stock = action.qtt;
          //         if (pd.current_max <= pd.current_stock) {
          //           console.log('innnn');
          //           pd.current_stock = pd.current_max;
          //           console.log('currentafter111', pd.current_stock);
          //         }
          //       }
          //       //decrease stock
          //       else {
          //         console.log('currentbefore222', pd.current_stock);
          //         if (pd.current_stock > pd.current_max) {
          //         }
          //         pd.current_stock = action.qtt;
          //         if (pd.current_stock < 0) pd.current_stock = 0;
          //         console.log('currentAFTER222', pd.current_stock);
          //       }
          //     }
          //   });
          // }
          console.log('update', update);

          return update;
        }
      }

      case 'increase': {
        const productIndex = state.findIndex((item) => item._id === action.product._id);
        if (productIndex < 0) {
          return state;
        }

        return state.map((item, index) =>
          index === productIndex ? { ...item, current_stock: action.qtt } : item
        );
      }
      default:
        return state;
    }
  }

  function decreStock(product, qtt) {
    setProds({ product, qtt, mycart: cart, type: 'decrement' });
  }

  function increaseStock(product, qtt) {
    setProds({ product, qtt, type: 'increase' });
  }

  function setAllProds(product) {
    setProds({ product, type: 'add' });
  }

  function changeProdPrice(product) {
    setCart({ product, type: 'changeProdPrice' });
  }

  useEffect(() => {
    const storedCart = JSON.parse(localStorage.getItem(LOCAL_STORAGE_KEY));
    if (storedCart) {
      setCart({ storedCart, type: 'addArray' });
    }
  }, []);

  useEffect(() => {
    localStorage.setItem(LOCAL_STORAGE_KEY, JSON.stringify(cart));
    const totalQtt = cart.reduce((total, item) => {
      return (total += item.quantity);
    }, 0);
    setCartQuantity(totalQtt);
    cartRef.current = cart;
  }, [cart]);

  //send web application status to database
  useEffect(() => {
    if (!(process.env.REACT_APP_DEV === 'TRUE')) {
      var interval = setInterval(() => updateActive(), 60000);
      return () => {
        clearInterval(interval);
      };
    }
  }, []);
  const updateActive = async () => {
    const mid = localStorage.getItem('machineID');
    if (mid) {
      let version = '0.0.0';
      let freedisk = null;

      try {
        const res = await localRequest({
          method: 'get',
          url: `/getVersion`,
          timeout: 10000,
        });
        version = p.version + ' + ' + res.data.version;
        freedisk = res.data.freedisk;
      } catch (err) {
        logger(0, 'failed to get version' + JSON.stringify(err));
      }

      try {
        await request({
          method: 'post',
          url: `/machines/updateStatus`,
          data: {
            id: mid,
            version: version,
            freedisk: freedisk,
          },
        });
        logger(2, 'updated status');
        setIsServerConnected(true);
        setLastChecked(new Date());
      } catch (err) {
        logger(0, 'failed to update status' + JSON.stringify(err));
        setIsServerConnected(false);
        setLastChecked(new Date());
      }

      console.log('update active');
    }
  };

  function cartReducer(state, action) {
    switch (action.type) {
      case 'addArray': {
        return [...action.storedCart];
      }
      case 'add': {
        if (cartQuantity >= MAXCARTNUM) {
          setCartFull(true);
          return state;
        } else {
          if (
            state?.length >= 1 &&
            (state[0].prodType === 'bundle' || action.product.prodType === 'bundle')
          ) {
            Swal.fire({
              showConfirmButton: false,
              timer: 3000,
              timerProgressBar: true,
              text: t(`You can only purchase one bundle at a time.`),
              icon: 'error',
            });
            const productIndex = products.findIndex((pd) => pd._id === action.product._id);
            increaseStock(action.product, products[productIndex].current_stock + 1);
            return state;
          }

          // if (action.product.category?.length > 0 && action.product.limit > 0) {
          //   let qqt = action.product.limit;
          //   state.forEach((pd) => {
          //     if (pd.category?.length > 0 && pd.category[0] === action.product.category[0]) {
          //       qqt -= pd.quantity;
          //     }
          //   });
          //   console.log('qqt', qqt);
          //   if (qqt <= 0) {
          //     Swal.fire({
          //       showConfirmButton: false,
          //       timer: 3000,
          //       timerProgressBar: true,
          //       text: `You can only purchase ${action.product.limit} item in this category.`,
          //       icon: 'error',
          //     });
          //     return state;
          //   }
          // }

          if (themeColor?.pop_text_addtocart === 'true') {
            let text = ' has been added to the cart';
            if (themeColor?.addToCartStyle === '1') text = ' has been added to the bag';
            Swal.fire({
              text: action.product?.name?.en + text,
              icon: 'success',
              showCancelButton: true,
              confirmButtonText: t('Checkout'),
              cancelButtonText: t('Continue shopping'),
              reverseButtons: true,
              timer: 10000,
            }).then((result) => {
              if (result.isConfirmed) {
                setShowCart(true);
                // Auto-click checkout button after cart opens
                setTimeout(() => {
                  const checkoutButton = document.getElementById('check-out-button');
                  if (checkoutButton) {
                    checkoutButton.click();
                  }
                }, 500);
              }
            });
          }

          return [...state, action.product];
        }
      }
      case 'remove': {
        const productIndex = state.findIndex((item) => item.id === action.product.id);
        if (productIndex < 0) {
          return state;
        }
        const update = [...state];
        update.splice(productIndex, 1);
        return update;
      }
      case 'chgQuantity': {
        const productIndex = state.findIndex((item) => item.id === action.product.id);
        if (productIndex < 0) {
          return state;
        }
        if (
          state[productIndex].promoType === 'oneTime' ||
          state[productIndex].promoType === 'nextPurchase'
        ) {
          Swal.fire({
            showConfirmButton: false,
            timer: 3000,
            timerProgressBar: true,
            text: 'One time code only allow to purcahse 1 item.',
            icon: 'error',
          });
          return state;
        }
        if (cartQuantity >= MAXCARTNUM && state[productIndex].quantity < action.quantity) {
          setCartFull(true);
          return state;
        } else {
          if (themeColor?.pop_text_addtocart === 'true') {
            let text = ' has been added to the cart';
            if (themeColor?.addToCartStyle === '1') text = ' has been added to the bag';
            if (state[productIndex].quantity < action.quantity)
              Swal.fire({
                text: state[productIndex].name?.en + text,
                icon: 'success',
                showCancelButton: true,
                confirmButtonText: t('Checkout'),
                cancelButtonText: t('Continue shopping'),
                reverseButtons: true,
              }).then((result) => {
                if (result.isConfirmed) {
                  setShowCart(true);
                  // Auto-click checkout button after cart opens
                  setTimeout(() => {
                    const checkoutButton = document.getElementById('check-out-button');
                    if (checkoutButton) {
                      checkoutButton.click();
                    }
                  }, 500);
                }
              });
          }

          const update = [...state];
          update[productIndex].quantity = action.quantity;
          return update;
        }
      }
      case 'changePrice': {
        const productIndex = state.findIndex((item) => item.id === action.product.id);
        if (productIndex < 0) {
          return state;
        }
        const update = [...state];
        update[productIndex].discount = action.discount;
        update[productIndex].discountedPrice = action.discountedPrice;
        update[productIndex].buyX = action.buyX;
        update[productIndex].percentage = action.percentage;
        update[productIndex].promo = action.promo;
        return update;
      }
      case 'clean': {
        // console.log('cleancleancleanclean222222', state);
        // console.log('cleancleancleanclean222222products', products);

        state?.forEach((item) => {
          const productIndex = products.findIndex((pd) => pd._id === item.id);
          increaseStock(item, products[productIndex].current_stock + item?.quantity);
        });

        const update = [];
        return update;
      }
      case 'getQuantity': {
        const cart = [...state];
      }
      default:
        return state;
    }
  }

  function add(product) {
    const funcAdd = () => {
      if (!(cartQuantity >= MAXCARTNUM)) {
        const index = stat?.prod.findIndex((item) => item._id === product._id);
        if (index >= 0) {
          stat.prod[index].add_to_cart = stat.prod[index].add_to_cart += 1;
        } else {
          stat.prod.push({
            _id: product._id,
            detail: 0,
            specs: 0,
            includes: 0,
            name: product.name?.en,
            add_to_cart: 1,
            conv: 0,
          });
        }
        setStat(stat);
        console.log(stat);
      }

      setCart({ product, type: 'add' });
    };

    if (product?.pop_alert?.en) {
      let pop_alert = product.pop_alert[langs] ? product.pop_alert[langs] : product.pop_alert.en;
      Swal.fire({
        text: pop_alert,
        icon: 'warning',
        showCancelButton: true,
        confirmButtonText: 'Yes',
        cancelButtonText: 'No',
      }).then((result) => {
        if (result.isConfirmed) {
          funcAdd();
        } else {
          return;
        }
      });
    } else {
      funcAdd();
    }
  }

  function remove(product) {
    setCart({ product, type: 'remove' });
  }

  function alterQuantity(product, quantity, isIncrement) {
    setCart({ product, type: 'chgQuantity', quantity: quantity });
  }

  function cleanUp() {
    setCart({ type: 'clean' });
    // setProds({ type: 'clean' });
  }

  function changePrice(product, discount, discountedPrice, buyX, percentage, promo) {
    setCart({
      product,
      type: 'changePrice',
      discount: discount,
      discountedPrice: discountedPrice,
      buyX: buyX,
      percentage: percentage,
      promo: promo,
    });
  }

  function idleScreenSaver() {
    if (
      window.location.pathname.indexOf('/machineUI/') === 0 &&
      window.location.pathname.indexOf('/machineUI/out-of-order') !== 0 &&
      window.location.pathname.indexOf('/machineUI/product-dispense') !== 0 &&
      window.location.pathname.indexOf('/machineUI/slider') !== 0 &&
      window.location.pathname.indexOf('/machineUI/home/') !== 0
    ) {
      return <IdleTimer machine={machine} idle={idle} />;
    } else {
      return null;
    }
  }

  function disability() {
    if (
      window.location.pathname.indexOf('/machineUI/') === 0 &&
      window.location.pathname.indexOf('/machineUI/payment') !== 0 &&
      window.location.pathname.indexOf('/machineUI/product-dispense') !== 0 &&
      window.location.pathname.indexOf('/machineUI/out-of-order') !== 0
    ) {
      // return <Disability />;
      return null;
    } else {
      return null;
    }
  }
  // navigator.onLine ? (
  return (
    <div className="App">
      {idleScreenSaver()}
      {disability()}
      {loading && <LoadingIcon />}
      <CartFullModal show={cartFull} setCartFull={setCartFull} />
      <NetworkStatusIndicator isServerConnected={isServerConnected} lastChecked={lastChecked} />
      <UserContext.Provider
        value={{
          loginStatus,
          setLoginStatus,
          userName,
          user,
          setUser,
          setUserName,
          role,
          setRole,
          userEmail,
          setUserEmail,
          referTo,
          setReferTo,
          fullAccess,
          setFullAccess,
          machineID,
          setMachineID,
          setTestMode,
          testMode,
          stat,
          setStat,
        }}
      >
        <AnimatePresence exitBeforeEnter>
          <Switch location={location} key={location.pathname}>
            <Route
              exact
              path="/machineUI/slider/:id/"
              render={(props) => (
                <ImageSlider
                  stat={stat}
                  cleanUp={cleanUp}
                  defaultStat={defaultStat}
                  setStat={setStat}
                  id={props.match.params.id}
                  linkPromo={linkPromo}
                  cartQuantity={cartQuantity}
                  setLinkPromo={setLinkPromo}
                />
              )}
            />
            <Route
              exact
              path="/machineUI/homePage/:id"
              render={(props) => (
                <Home
                  products={products}
                  cleanUp={cleanUp}
                  setClientUser={setClientUser}
                  clientUser={clientUser}
                  setLoading={setLoading}
                  HFuser={HFuser}
                  audio={audio}
                  stopPlay={stopPlay}
                  closePromoModalRef={closePromoModalRef}
                  promoRef={promoRef}
                  changePrice={changePrice}
                  themeColor={themeColor}
                  stat={stat}
                  setStat={setStat}
                  showCart={showCart}
                  setShowCart={setShowCart}
                  id={props.match.params.id}
                  add={add}
                  cart={cart}
                  decreStock={decreStock}
                  itemCounter={cartQuantity}
                  changeProdPrice={changeProdPrice}
                  alterquantity={alterQuantity}
                  langs={langs}
                  remove={remove}
                  setCartFull={setCartFull}
                  setlangs={setlangs}
                />
              )}
            />
            <Route
              exact
              path="/machineUI/product/:machineID/:id/:index"
              render={(props) => (
                <DescriptionPage
                  products={products}
                  cleanUp={cleanUp}
                  setLoading={setLoading}
                  setClientUser={setClientUser}
                  clientUser={clientUser}
                  HFuser={HFuser}
                  audio={audio}
                  stopPlay={stopPlay}
                  closePromoModalRef={closePromoModalRef}
                  promoRef={promoRef}
                  changePrice={changePrice}
                  stat={stat}
                  setStat={setStat}
                  setlangs={setlangs}
                  showCart={showCart}
                  setShowCart={setShowCart}
                  id={props.match.params.id}
                  add={add}
                  cart={cart}
                  decreStock={decreStock}
                  itemCounter={cartQuantity}
                  changeProdPrice={changeProdPrice}
                  alterquantity={alterQuantity}
                  langs={langs}
                  remove={remove}
                  i={props.match.params.index}
                  setCartFull={setCartFull}
                />
              )}
            />

            <Route
              exact
              path="/machineUI/category/:brandOrCate/:catename/:id"
              render={(props) => (
                <CategoryPage
                  productss={products}
                  cleanUp={cleanUp}
                  setLoading={setLoading}
                  setClientUser={setClientUser}
                  clientUser={clientUser}
                  HFuser={HFuser}
                  audio={audio}
                  stopPlay={stopPlay}
                  closePromoModalRef={closePromoModalRef}
                  promoRef={promoRef}
                  changePrice={changePrice}
                  stat={stat}
                  setStat={setStat}
                  setlangs={setlangs}
                  showCart={showCart}
                  setShowCart={setShowCart}
                  add={add}
                  cart={cart}
                  decreStock={decreStock}
                  itemCounter={cartQuantity}
                  changeProdPrice={changeProdPrice}
                  alterquantity={alterQuantity}
                  langs={langs}
                  remove={remove}
                  machineID={props.match.params.id}
                  catename={props.match.params.catename}
                  id={props.match.params.id}
                  brandOrCate={props.match.params.brandOrCate}
                  setCartFull={setCartFull}
                />
              )}
            />
            <Route
              exact
              path="/machineUI/home/:id/:test"
              render={(props) => (
                <Initial
                  setClientUser={setClientUser}
                  setAudio={setAudio}
                  audio={audio}
                  stopPlay={stopPlay}
                  setThemeColor={setThemeColor}
                  stat={stat}
                  setStat={setStat}
                  setLinkPromo={setLinkPromo}
                  linkPromo={linkPromo}
                  setShowCart={setShowCart}
                  setlangs={setlangs}
                  setTestMode={setTestMode}
                  setMachine={setMachine}
                  setProds={setAllProds}
                  id={props.match.params.id}
                  test={props.match.params.test}
                  cleanUp={cleanUp}
                />
              )}
            />

            <Route
              exact
              path="/machineUI/payment/:id"
              render={(props) => (
                <PaymentPrompt
                  id={props.match.params.id}
                  cart={cart}
                  langs={langs}
                  idle={idle}
                  setIdle={setIdle}
                  setShowCart={setShowCart}
                />
              )}
            />
            <Route
              exact
              path="/machineUI/selectPayment/:id"
              render={(props) => (
                <SelectPayment
                  id={props.match.params.id}
                  cart={cart}
                  langs={langs}
                  idle={idle}
                  setIdle={setIdle}
                  setShowCart={setShowCart}
                />
              )}
            />
            <Route
              exact
              path="/machineUI/cashPayment/:id"
              render={(props) => (
                <CashPayment
                  id={props.match.params.id}
                  cart={cart}
                  langs={langs}
                  idle={idle}
                  setIdle={setIdle}
                  setShowCart={setShowCart}
                />
              )}
            />
            <Route
              exact
              path="/machineUI/product-dispense/:id"
              render={(props) => (
                <ProductDispense
                  clientUser={clientUser}
                  HFuser={HFuser}
                  audio={audio}
                  stopPlay={stopPlay}
                  linkPromo={linkPromo}
                  langs={langs}
                  stat={stat}
                  setStat={setStat}
                  id={props.match.params.id}
                  machine={machine}
                  cart={cart}
                />
              )}
            />
            <Route
              exact
              path="/machineUI/emailCode/:id"
              render={(props) => (
                <EmailCode langs={langs} id={props.match.params.id} machine={machine} />
              )}
            />
            <Route
              exact
              path="/machineUI/out-of-order/:id"
              render={(props) => <OutOfOrder id={props.match.params.id} />}
            />
            <Route
              exact
              path="/techMode/productInventory"
              render={(props) => <ProductInventory />}
            />
            <Route exact path="/techMode/lockerInventory" render={(props) => <LockerInventory />} />
            <Route
              exact
              path="/machineUI/helloFresh/:id"
              render={(props) => (
                <ScanPage setLoading={setLoading} setHFuser={setHFuser} setProds={setAllProds} />
              )}
            />
            <Route exact path="/machineSignIn/:page" component={MachineSignIn} />
            <Route exact path="/machineSignIn" component={MachineSignIn} />
            <Route exact path="/synch" render={(props) => <Synch loginStatus={loginStatus} />} />
            <Route path="/logout" component={Logout} />
            <Route component={NotFound} />
          </Switch>
        </AnimatePresence>
      </UserContext.Provider>
    </div>
  );
  // ) : (
  //   <NoInt />
  // );
}

export default App;
